import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import HelocCalculator from './HelocCalculator.js';
import { FieldConfig } from './HelocCalculator.utils.js';

var _attributes;
var HelocCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var homeValue = attrs.homeValue,
      loanBalance = attrs.loanBalance;
    var defaultValues = {
      homeValue: homeValue,
      loanBalance: loanBalance
    };
    return /*#__PURE__*/React.createElement(HelocCalculator, {
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues,
      editorMode: isEditor()
    });
  },
  metadata: {
    $schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'constellation/heloc-calculator',
    title: 'Home Equity Line of Credit (HELOC) Calculator',
    description: 'See if you qualify for a home equity line of credit.',
    icon: 'calculator',
    keywords: ['HELOC', 'calculator'],
    supports: {
      customClassName: false,
      html: false
    },
    attributes: (_attributes = {}, _attributes[FieldConfig.homeValue.name] = {
      type: 'number',
      label: 'Default home value',
      default: 400000,
      control: 'number'
    }, _attributes[FieldConfig.loanBalance.name] = {
      type: 'number',
      label: 'Default loan balance',
      default: 300000,
      control: 'number'
    }, _attributes)
  }
};
var HelocCalculatorBlock$1 = HelocCalculatorBlock;

export { HelocCalculatorBlock$1 as default };
